export const featureKey = 'genesysCloudIntegrations';
